<template>
<b-container
  class="py-5 d-flex section"
  fluid
  >
  <b-row class="justify-content-center align-self-center mx-auto">
    <b-col>
      
      <b-container class="text-center" fluid>
	<b-row>
	  <b-col>
	    <div class="mt-5">
	      <h2>TrinApps share
		<br>your data in your TrinPod<sup>&trade;</sup></h2>
	    </div>
	  </b-col>
	</b-row>
	<b-row>
	  <b-col>
	    <slot name="icon">
	      <b-img
		:src="require('../assets/trinity_secure.png')"
		class="pt-5"
		style="width: 200px;"
		/>
	    </slot>
	    <b-jumbotron class="pt-3 bg-light">	  
	      <div class="pb-3">
		<h1>TrinPod<sup>&trade;</sup></h1>
	      </div>
	      <div class="m-auto">
		<p class="mb-0">Industrial strength Solid Pod </p>
		<p class="mb-0">capable of handling a massive amount of data,</p>
		<p class="mb-0">stored in a graph DB</p>
		<p class="mb-0">with conceptual computing through Trinity AI.</p>
	      </div>
	      <b-button
		size="lg"
		class="btn-yellow mt-5 mx-3"
		style="width: 200px;"
		to="/construction/trinpod"
		@click.native="scrollToTop()"
		>
		TrinPod<sup>&trade;</sup>
	      </b-button>
	      <b-button
		size="lg"
		class="btn-orange mt-5 mx-3"
		href="https://trinpod.us/pricing?industry=construction"
		>
		Get Started
	      </b-button>
	    </b-jumbotron>
	  </b-col>
	</b-row>
      </b-container>
      
    </b-col>
  </b-row>
</b-container>
</template>

<script>
export default {
    name: "Layout11",
    methods: {
	img: function (image) {
	    require(image)
	},
        scrollToTop: function () {
	    window.scrollTo(0,0);
        }
    }
}
</script>
